<div class="top-bar">
    <nav class="container">
        <div class="row justify-content-end">
            <div class="col-md-6 col-sm-12 navbar-header">
              <component-navigation></component-navigation>
            </div>
            <div class="col-md-6 text-right hidden-sm-down" style="margin-top: 15px;">
                <a href="https://www.facebook.com/angelcrypt/" target="_blank"><i class="top-icon fab fa-facebook-f"></i></a>
                <a href="https://www.instagram.com/angelcrypt/" target="_blank"><i class="top-icon fab fa-instagram"></i></a>
                <a href="https://www.youtube.com/user/angelcrypt" target="_blank"><i class="top-icon fab fa-youtube"></i></a>
                <a href="https://twitter.com/angelcryptband" target="_blank"><i class="top-icon fab fa-twitter"></i></a>
            </div>
        </div>
    </nav>
</div>

